if (typeof boostPFSThemeConfig !== "undefined") {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: true,
      numberFilterTree: 2,
      selectOptionContainer: ".grid__item .card-wrapper",
      stickyFixTopPos: true,
    },
    selector: {
      otpTopCartCount: ".cart-count-bubble",
    },
  };
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== "undefined" && theme.hasOwnProperty("settings"))
  theme.settings.predictiveSearchEnabled = false;

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];

  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop =
    jQ(".boost-pfs-filter-left-col").length > 0 && !Utils.isMobile()
      ? ".boost-pfs-filter-left-col"
      : ".boost-pfs-filter-tree";
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    var saleClass = onSale ? boostPFSTemplate.saleClass : "";

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(
      /{{cardProductClass}}/g,
      buildCardProductClass()
    );
    // Add Card Product ID
    itemHtml = itemHtml.replace(/{{cardProductID}}/g, buildCardProductID(data));
    // Add Card Product Form By Status
    itemHtml = itemHtml.replace(
      /{{productStatusForm}}/g,
      buildProductCardFormStatus(data)
    );
    // Add Card Product First Variant ID
    itemHtml = itemHtml.replace(
      /{{cardProductVariantID}}/g,
      buildCardProductVariantID(data)
    );
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    // Check if customer is logged in
    if (!window.customerData?.loggedIn) {
      // Add Price if customer is NOT logged in
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    } else {
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, "");
      console.log("Customer is logged in. Skipping price display.");
    }

    // Add Badges
    itemHtml = itemHtml.replace(/{{customBadges}}/g, buildBadges(data));
    // Add Icon Badges
    itemHtml = itemHtml.replace(/{{iconBadges}}/g, buildIconBadges(data));

    // Add Review
    if (
      typeof Integration === "undefined" ||
      (typeof Integration != "undefined" &&
        typeof Integration.hascompileTemplate == "function" &&
        !Integration.hascompileTemplate("reviews"))
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemSku}}/g, data.variants[0].sku);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var tags = data.tags.filter((tag) => tag.includes("icon-"));

    var html = "",
      aspectRatio = "",
      rangeWidths = boostPFSRangeWidths,
      paddingBottom = 100;

    var dataSrcSet = "",
      imgAlt = data.title,
      flipImageSrcSet = "";

    var activeSwapImage =
      !Utils.isMobile() &&
      images.length > 1 &&
      boostPFSThemeConfig.custom.hasOwnProperty("show_secondary_image") &&
      boostPFSThemeConfig.custom.show_secondary_image == true;

    for (var i = 0; i < rangeWidths.length; i++) {
      dataSrcSet +=
        Utils.getFeaturedImage(images, rangeWidths[i] + "x") +
        " " +
        rangeWidths[i] +
        "w";

      if (activeSwapImage) {
        flipImageSrcSet +=
          Utils.optimizeImage(images[1]["src"], rangeWidths[i] + "x") +
          " " +
          rangeWidths[i] +
          "w";
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ", ";

        if (activeSwapImage) {
          flipImageSrcSet += ", ";
        }
      }
    }

    if (images.length > 0) {
      aspectRatio = images[0]["width"] / images[0]["height"];
      paddingBottom = (1 / aspectRatio) * 100;

      html += `
				<a class="d-block" href="${window.shopUrl + "/products/" + data.handle}">
					<div class="square bg-contain" style="background-image:url(${Utils.optimizeImage(
            images[0].src,
            "533x"
          )})">
						<div class="content">
							<div class="content-inner">`;

      html += `</div>
						</div>
					</div>
				</a>
			`;

      html += "<div";
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("add_image_padding") &&
        boostPFSThemeConfig.custom.add_image_padding === true
      ) {
        html += ' class="d-none card__media-full-spacer"';
      }
      html += ">";
      html += '<div class="d-none media media--transparent media--';
      if (boostPFSThemeConfig.custom.hasOwnProperty("media_size")) {
        html += boostPFSThemeConfig.custom.media_size;
      }
      html += ' media--hover-effect"';
      if (
        boostPFSThemeConfig.custom.hasOwnProperty("media_size") &&
        boostPFSThemeConfig.custom.media_size == "adapt" &&
        images.length > 0
      ) {
        html += ' style="padding-bottom: ' + paddingBottom + '%"';
      }
      html += ">";
      html +=
        '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' +
        dataSrcSet +
        '" ' +
        'height="' +
        images[0].height +
        '" ' +
        'width="' +
        images[0].width +
        '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
        'src="' +
        Utils.optimizeImage(images[0].src, "533x") +
        '" ' +
        'alt="' +
        imgAlt +
        '" />';

      if (activeSwapImage) {
        html +=
          '<img class="motion-reduce"' +
          'loading="lazy"' +
          'srcset="' +
          flipImageSrcSet +
          '" ' +
          'height="' +
          images[1].height +
          '" ' +
          'width="' +
          images[1].width +
          '" ' +
          'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
          'src="' +
          Utils.optimizeImage(images[1].src, "533x") +
          '" ' +
          'alt="' +
          imgAlt +
          '" />';
      }
      html += "</div>";
      html += "</div>";
    } else {
      html +=
        '<div class="card__content"><h2 class="card__text h2">' +
        data.title +
        "</h2></div>";
    }
    return html;
  }

  function buildCardProductClass() {
    var html = "";
    if (!images || (images && images.length === 0)) {
      html = "card--text-only card--soft";
    } else if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_image_outline") &&
      boostPFSThemeConfig.custom.show_image_outline
    ) {
      html = "card--outline";
    }
    return html;
  }

  function buildCardProductID(data) {
    var html = data.id;
    return html;
  }

 function buildProductCardFormStatus(data) {
  var html = "";

  // --- Inputs / guards ---
  var customer_status = (window.customer && window.customer.status) || "";
  var shipping_tag = "normal";
  var tags = Array.isArray(data.tags) ? data.tags : [];
  var email_for_price = tags.includes("product-status:email-for-price");
  var add_to_cart_for_price = tags.includes("product-status:add-to-cart-for-price");
  var map_price = tags.includes("product-status:map-price");
  var tier_pricing = !!(window.customerData && window.customerData.loggedIn);

  // Money formatting helper (fallback if Shopify.formatMoney is unavailable)
  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        var fmt =
          (window.theme && window.theme.moneyFormat) ||
          Shopify.money_format ||
          "${{amount}}";
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  // Derive shipping tag
  tags.forEach(function (tag) {
    if (tag.indexOf("shipping-status:") === 0) {
      var parts = tag.split(":");
      shipping_tag = parts[1] || "normal";
    }
  });

  html += '<div class="product-card-buttons">';

  // Show EMAIL/QUOTE form when:
  // - email_for_price (for ALL customers), OR
  // - map_price AND (customer is ecomm-tier OR not logged in)
  if (email_for_price || (map_price && (customer_status === "ecomm-tier" || customer_status === ""))) {
    var sku =
      (data.skus && data.skus[0]) ||
      (data.variants && data.variants[0] && data.variants[0].sku) ||
      "";
    var primaryVariantId =
      data.variants && data.variants[0] ? data.variants[0].id : "";
    var raw = (data.price != null
      ? data.price
      : (data.variants && data.variants[0] && data.variants[0].price)) || 0;

    var mapCents = Math.round(Number(raw) * 100);

    var mapPriceStr = (window.Shopify && typeof Shopify.formatMoney === "function")
      ? Shopify.formatMoney(mapCents, "{{amount}}")
      : (mapCents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    var reqFieldName = email_for_price
      ? "email_for_price_request"
      : "map_email_for_price_request";
    var reqFieldId = email_for_price
      ? "email_for_price_request"
      : "map_email_for_price_request";
    var reqLabel = email_for_price ? "Email For Price" : "MAP PRICE";

    html += `<product-email-form>
      <div class="email-holder">
        <form method="post" data-action="/contact#contact_form" data-id="contact_form" accept-charset="UTF-8" class="contact-form">
          <input type="hidden" name="form_type" value="contact" tabindex="0">
          <input type="hidden" name="utf8" value="✓" tabindex="0">

          <p class="small email-message mb-2 px-2">Enter your email &amp; we'll send you a quote.</p>

          <div class="form-holder">
            <div class="email-for-price hidden">
              <label for="${reqFieldId}">${reqLabel}</label>
              <input type="text" name="contact[${reqFieldName}]" id="${reqFieldId}" value="${String(
                data.title || ""
              ).replace(/"/g, "&quot;")}" />
            </div>

            ${
              tier_pricing
                ? `
            <div class="email-for-price hidden">
              <label for="tier_pricing">TIER PRICING</label>
              <input type="text" name="contact[tier]" id="tier_pricing" value="TIER PRICING">
            </div>`
                : ""
            }

            ${
              map_price
                ? `
            <div class="email-for-price hidden">
              <label for="map_pricing">MAP PRICE</label>
              <input type="text" name="contact[MAP PRICE]" id="map_pricing" value="${mapPriceStr}">
            </div>`
                : ""
            }

            <div class="email-for-price hidden">
              <label for="email_for_price_request_collection">Collection</label>
              <input type="text" name="contact[method]" id="email_for_price_request_collection" value="GV" />
            </div>

            <div class="product-id hidden">
              <label for="product_sku">Product SKU</label>
              <input type="text" name="contact[product_sku]" id="product_sku" value="${sku}" tabindex="0">
            </div>

            <div class="product-title hidden">
              <label for="product_title">Product Title</label>
              <input type="text" name="contact[product_title]" id="product_title" value="${String(
                data.title || ""
              ).replace(/"/g, "&quot;")}" tabindex="0">
            </div>

            <div class="email-for-price hidden">
              <label for="product_url">Product URL</label>
              <input type="text" name="contact[product_url]" id="product_url" value="https://nellacutlery.ca/products/${
                data.handle
              }">
            </div>

            <div class="input-group">
              <input type="email" class="form-control form-control-sm" placeholder="Email Address" aria-label="Email Address" aria-describedby="button-addon2" name="contact[email]" data-id="email" tabindex="0">
              <button class="btn-sm btn-grey" type="submit" data-id="button-addon2" tabindex="0">Send</button>
            </div>
          </div>

          <div class="form-message d-none small mt-2 text-danger"></div>
        </form>
      </div>
    </product-email-form>`;
  } else {
    // Normal add-to-cart form
    var maxQtyAttr = "";
    if (tags.includes("deny") && data.variants && data.variants[0] && data.variants[0].inventory_quantities) {
      var inv = data.variants[0].inventory_quantities["Nella Cutlery"];
      if (typeof inv !== "undefined") maxQtyAttr = `max="${inv}"`;
    }

    html += `<div id="ProductInfo-${data.id}" class="w-100">
      <product-form>
        <div class="product-form__error-message-wrapper" role="alert" hidden="">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13" width="15" height="15">
            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
            <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
            <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
          </svg>
          <span class="product-form__error-message" style="font-size: 14px;"></span>
        </div>
        <form method="post" action="/cart/add" id="product-form-${data.id}" accept-charset="UTF-8" class="form w-100" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
          <input type="hidden" name="form_type" value="product" tabindex="0">
          <input type="hidden" name="utf8" value="✓" tabindex="0">
          <input type="hidden" name="id" value="${data.variants && data.variants[0] ? data.variants[0].id : ""}" tabindex="0">

          <div class="btn-holder w-100">
            <quantity-input>
              <input class="form-control form-control-sm number" type="number" name="quantity" id="Quantity-${data.id}" min="1" value="1" form="product-form-${data.id}" ${maxQtyAttr} tabindex="0">
            </quantity-input>

            <button
              type="submit"
              name="add"
              class="btn-sm btn-tertiary add-btn"
              data-product-type="${data.product_type}"
              data-shipping-type="${shipping_tag}"
              tabindex="0"
              aria-haspopup="dialog"
            >${
              tags.includes("deny")
                ? `<script>
                  document.getElementById('Quantity-${data.id}').addEventListener('input', function() {
                    const max = parseInt(this.max, 10);
                    if (parseInt(this.value, 10) > max) {
                      this.value = max;
                    }
                  });
                </script>`
                : ""
            }`;

    if (
      (add_to_cart_for_price && customer_status === "ecomm-tier") ||
      (add_to_cart_for_price && customer_status === "")
    ) {
      html += `<span>Add for price</span>`;
    } else {
      html += `<span>Add to cart</span>`;
    }

    html += `<div class="loading-overlay__spinner hidden d-none d-lg-inline-block">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" stroke="#FFF" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>
          </div>
        </form>
      </product-form>
    </div>`;
  }

  html += "</div>";

  return html;
}


  function buildCardProductVariantID(data) {
    var html = data.variants[0].id;
    return html;
  }

  function buildVendor(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_vendor") &&
      boostPFSThemeConfig.custom.show_vendor === true
    ) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

 function buildPrice(data) {
  var html = "";

  // Fix/guards
  var priceVaries = !!data.price_varies;
  var soldOut = !data.available;
  var onSale = Number(data.compare_at_price_min || 0) > Number(data.price_min || 0);

  var noComparePrice = data.price_varies === false && data.compare_at_price_varies;

  var priceAmount = boostPFSConfig.custom.currency_code_enabled
    ? Utils.formatMoney(data.price_min, "money_with_currency")
    : Utils.formatMoney(data.price_min);

  var compareAtPrice = boostPFSConfig.custom.currency_code_enabled
    ? Utils.formatMoney(data.compare_at_price_min, "money_with_currency")
    : Utils.formatMoney(data.compare_at_price_min);

  var moneyPrice = priceVaries
    ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
    : priceAmount;

  var hide = data.compare_at_price_min === data.price_min ? "d-none" : "";

  var unitPriceClass =
    !data.available ||
    typeof data?.selected_or_first_available_variant?.unit_price_measurement === "undefined"
      ? "hidden"
      : "";

  var email_for_price = data.tags.includes("product-status:email-for-price");
  var add_to_cart_for_price = data.tags.includes("product-status:add-to-cart-for-price");
  var map_price = data.tags.includes("product-status:map-price"); // NEW: hide strike-through when true

  var customer_tier = (window.customer && window.customer.status) || "";
  var customer_tier_upscale =
    customer_tier === "gold-tier" || customer_tier === "platinum-tier" ? true : false;

  var same_price = "";
  if (compareAtPrice === moneyPrice) {
    same_price = "d-none";
  }

  var uom = "Case";
  var custom_uom = data.tags.filter(function (value) {
    return value.indexOf("UOMDESC:") === 0;
  });
  if (custom_uom.length) {
    uom = custom_uom[0].split(":")[1];
  }

  // Ecomm-tier or not logged-in
  if (customer_tier === "ecomm-tier" || customer_tier === "") {
    html = `
      <div class="product-card-price">
        <div class="small mb-2">
          <div class="price ${soldOut ? "price--sold-out" : ""} ${onSale ? "price--on-sale" : ""}${
      noComparePrice ? " price--no-compare" : ""
    }">
            <div>
              <!-- Compare-at (strike). Hide if same price, email-for-price, OR MAP -->
              <div class="price-each small ${same_price} ${email_for_price || map_price ? "d-none" : ""}">
                <span class="price-item">
                  <s class="text-danger fw-bold">${compareAtPrice}</s>
                  <span class="indicator">/ ${uom}</span>
                </span>
              </div>

              <!-- Sell price (keep visible for MAP; hide only for email/add-to-cart-for-price) -->
              <div class="price-dozen ${email_for_price || add_to_cart_for_price ? "d-none" : ""}">
                <span class="price-item">
                  <span class="text-danger">${moneyPrice}</span>
                  <span class="indicator">/ ${uom}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>`;
  } else {
    // Gold/Platinum (retail compare shown normally unless MAP)
    html = `
      <div class="product-card-price">
        <div class="small mb-2">
          <div class="price ${soldOut ? "price--sold-out" : ""} ${onSale ? "price--on-sale" : ""}${
      noComparePrice ? " price--no-compare" : ""
    }">
            <div>
              <p class="mb-1 fw-bolder retail-price">Retail Price:</p>

              <!-- Compare-at (strike). Hide if same price OR MAP -->
              <div class="price-each small ${same_price} ${map_price ? "d-none" : ""}">
                <span class="price-item">
                  <s class="text-danger fw-bold">${compareAtPrice}</s>
                  <span class="indicator">/ ${uom}</span>
                </span>
              </div>

              <div class="price-dozen">
                <span class="price-item">
                  <span class="text-danger">${moneyPrice}</span>
                  <span class="indicator">/ ${uom}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>`;
  }

  return html;
}


  function buildIconBadges(data) {
    var tags = data.tags.filter((tag) => tag.includes("icon-"));

    html = "";
    if (tags.length) {
      html += `<ul class="list-unstyled m-0 p-0">`;
      tags.forEach((tag) => {
        var tag_clean_split = tag.split(":")[1];
        var tag_split = tag.split("-");
        var tag_type = tag_split[1].split(":")[0];
        var tag_text = tag_split[1].split(":")[1];
        switch (tag_type) {
          case "fire":
            html += `<li><i class="fas fa-fire-alt me-1"></i> <span>${tag_clean_split}</span></li>`;
            break;
          case "gas":
            html += `<li><i class="fas fa-fire-alt blue me-1"></i> <span>${tag_clean_split}</span></li>`;
            break;
          case "lightning":
            html += `<li><i class="fas fa-bolt me-1"></i> <span>${tag_clean_split}</span></li>`;
            break;
          case "ice":
            html += `<li><img src="${
              window.shopifyURLs.assets_url + "ice-cubes.svg"
            }" /> <span>${tag_clean_split}</span></li>`;
            break;
          case "charcoal":
            html += `<li><img src="${
              window.shopifyURLs.assets_url + "charcoal.svg"
            }" /> <span>${tag_clean_split}</span></li>`;
            break;
          default:
            html += `<li><i class="fas fa-plus-circle me-1"></i> <span>${tag_clean_split}</span></li>`;
        }
      });
      html += `</ul>`;
    }

    return html;
  }

  function buildBadges(data) {
  var tags = data.tags.filter((tag) => tag.includes("badge:"));
  var html = "";

  tags.forEach((tag) => {
    var label = tag.replace("badge:", "").trim();

    // build a slug for CSS class (same rules as Liquid version)
    var slug = label
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/\//g, "-")
      .replace(/\+/g, "plus")
      .replace(/[.,:;]+/g, "")
      .replace(/\s+/g, "-");

    html += `<li class="main-product-badge badge--${slug}">${label}</li>`;
  });

  return html;
}


  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty(
        "sold_out_badge_color_scheme"
      ) &&
      soldOut
    ) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
        /{{soldOutBadgeClass}}/g,
        boostPFSThemeConfig.custom.sold_out_badge_color_scheme
      );
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("sale_badge_color_scheme") &&
      onSale &&
      !soldOut
    ) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(
        /{{saleBadgeClass}}/g,
        boostPFSThemeConfig.custom.sale_badge_color_scheme
      );
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = "";
    if (
      boostPFSThemeConfig.custom.hasOwnProperty("show_product_review") &&
      boostPFSThemeConfig.custom.show_product_review == true &&
      Utils.getProductMetafield(data, "reviews", "rating") !== null
    ) {
      var ratingObj = JSON.parse(
        Utils.getProductMetafield(data, "reviews", "rating")
      );
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >= 0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info
        .replace("{{ rating_value }}", ratingObj.value)
        .replace("{{ rating_max }}", ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${
                  boostPFSConfig.custom.accent_icons
                }" style="--rating: ${Math.round(
        ratingObj.value.rating
      )}; --rating-max: ${
        ratingObj.value.scale_max
      }; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${
        ratingObj.value.scale_max
      }</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(
                  data,
                  "reviews",
                  "rating_count"
                )})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(
                  data,
                  "reviews",
                  "rating_count"
                )} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml =
      currentPage > 1 ? boostPFSTemplate.previousActiveHtml : "";
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml =
      currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : "";
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (
      var iBefore = currentPage - 1;
      iBefore > currentPage - 3 && iBefore > 0;
      iBefore--
    ) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift("...");
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (
      var iAfter = currentPage + 1;
      iAfter < currentPage + 3 && iAfter <= totalPage;
      iAfter++
    ) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push("...");
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = "";
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == "...") {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink("page", currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || "";
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          var isSelected = "";
          if (paramSort == k) {
            isSelected = 'selected="selected"';
          }
          sortingItemsHtml +=
            '<option value="' +
            k +
            '"' +
            isSelected +
            ">" +
            sortingArr[k] +
            "</option>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (
      jQ(".boost-pfs-filter-custom-sorting").hasClass(
        "boost-pfs-filter-sort-active"
      )
    ) {
      jQ(".boost-pfs-filter-custom-sorting").toggleClass(
        "boost-pfs-filter-sort-active"
      );
    }

    var labelSort = "";
    var paramSort = Globals.queryParams.sort || "";
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ(".boost-pfs-filter-custom-sorting button span span").text(labelSort);
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + " .facet-filters__sort").change(function (e) {
      e.preventDefault();
      FilterApi.setParam("sort", jQ(this).val());
      FilterApi.setParam("page", 1);
      FilterApi.applyFilter("sort");
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
  };

  // Build Additional Elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    jQ(".boost-pfs-filter-total-product").html(
      data.total_product + " products"
    );

    if (Utils.isSearchPage()) {
      var currentSearchHeader = jQ('.breadcrumbs__item a[href="/search"]')
        .text()
        .replace(/[0-9]+/, Utils.stripHtml(data.total_product));
      jQ('.breadcrumbs__item a[href="/search"]').text(currentSearchHeader);
    }
  };

  /************************** END BUILD TOOLBAR **************************/
})();
